var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-none w-56",attrs:{"aria-hidden":"true"}},[_c('p',{staticClass:"h-4 mb-2"}),_c('div',{staticClass:"w-full aspect-video rounded-lg border border-primary-400 bg-primary-500/20"})])
}]

export { render, staticRenderFns }